<div class="grid grid-gap">
  <div class="xs-7 m-9 l-10">
    <div class="search">
      <form (ngSubmit)="search()">
        <input type="search" placeholder="{{'search-filter.search-plholder' | i18next}}"
               (change)="setValue($event.target)" value="{{value}}">
      </form>
      <svg (click)="search()" id="Gruppe_320" data-name="Gruppe 320" xmlns="http://www.w3.org/2000/svg"
           xmlns:xlink="http://www.w3.org/1999/xlink" width="17.262" height="17.265" viewBox="0 0 17.262 17.265">
        <defs>
          <clipPath id="clip-path">
            <rect id="Rechteck_108" data-name="Rechteck 108" width="17.262" height="17.265" fill="#023e84"/>
          </clipPath>
        </defs>
        <g id="Gruppe_319" data-name="Gruppe 319" clip-path="url(#clip-path)">
          <path id="Pfad_147" data-name="Pfad 147"
                d="M17.142,16.563,11.5,10.922a6.591,6.591,0,1,0-.581.581l5.639,5.641a.411.411,0,1,0,.582-.581M6.576,12.33A5.754,5.754,0,1,1,12.33,6.576,5.761,5.761,0,0,1,6.576,12.33"
                fill="#023e84"/>
        </g>
      </svg>
    </div>
  </div>
  <div class="xs-5 m-3 l-2">
    <button class="btn white full" (click)="handleFilterOverlay()">
      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
           width="15.618"
           height="15.618" viewBox="0 0 15.618 15.618">
        <defs>
          <clipPath id="clip-path">
            <rect id="Rechteck_105" data-name="Rechteck 105" width="15.618" height="15.618"
                  transform="translate(0 0)" fill="#023e84"/>
          </clipPath>
        </defs>
        <g id="Gruppe_314" data-name="Gruppe 314" transform="translate(0 0)">
          <g id="Gruppe_313" data-name="Gruppe 313" clip-path="url(#clip-path)">
            <path id="Pfad_139" data-name="Pfad 139"
                  d="M14.8.822V2.944L9.575,7.351a.58.58,0,0,0-.051.047A1.632,1.632,0,0,0,9.042,8.56v3.856c-.03.022-.058.046-.086.071l-2.38,2.259V8.463a1.654,1.654,0,0,0-.494-1.175l-.051-.046L.822,2.939V.822ZM14.8,0H.822A.821.821,0,0,0,0,.822V2.943a.822.822,0,0,0,.247.587L5.506,7.876a.815.815,0,0,1,.248.587V14.8a.82.82,0,0,0,1.189.735l2.579-2.447a.821.821,0,0,0,.342-.667V8.56a.821.821,0,0,1,.241-.581l5.272-4.45a.82.82,0,0,0,.241-.581V.822A.821.821,0,0,0,14.8,0"
                  fill="#023e84"/>
          </g>
        </g>
      </svg>
      {{'search-filter.filter' | i18next}}
    </button>
  </div>

</div>
